const gql = String.raw;

export const ASSET_FRAGMENT = gql`
  fragment ResponsiveImageFragment on ResponsiveImage {
    aspectRatio
    alt
    base64
    height
    width
    sizes
    src
    srcSet
    webpSrcSet
  }
  fragment FileFieldFragment on FileField {
    height
    title
    width
    url
    format
  }
`;

export const DEFAULT_FRAGMENT = gql`
  fragment DefaultFragment on DefaultRecord {
    id
    _modelApiKey
    firstAssetDelay
    followingAssetsDelay
    assetRight {
      relativeLink
      videoLoop
      videoMuted
      asset {
        ...FileFieldFragment
        responsiveImage(
          imgixParams: { fm: webp, q: 60, fit: max, w: 600, h: 1024 }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    assetLeft {
      relativeLink
      videoLoop
      videoMuted
      asset {
        ...FileFieldFragment
        responsiveImage(
          imgixParams: { fm: webp, q: 60, fit: max, w: 600, h: 1024 }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    assetCenter {
      relativeLink
      videoLoop
      videoMuted
      asset {
        ...FileFieldFragment
        responsiveImage(
          imgixParams: { fm: webp, q: 60, fit: max, w: 1024, h: 1024 }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    backgroundAsset {
      videoLoop
      videoMuted
      asset {
        ...FileFieldFragment
        responsiveImage(
          imgixParams: { fm: webp, q: 60, fit: max, w: 1200, h: 1200 }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    backgroundColour {
      hex
    }
  }
`;
export const SPLIT_PAGE_FRAGMENT = gql`
  fragment SplitPageFragment on SplitPageRecord {
    id
    _modelApiKey
    firstAssetDelay
    followingAssetsDelay
    assetRight {
      videoLoop
      videoMuted
      asset {
        ...FileFieldFragment
        responsiveImage(
          imgixParams: { fm: webp, q: 60, fit: max, w: 600, h: 1024 }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    assetLeft {
      videoLoop
      videoMuted
      asset {
        ...FileFieldFragment
        responsiveImage(
          imgixParams: { fm: webp, q: 60, fit: max, w: 600, h: 1024 }
        ) {
          ...ResponsiveImageFragment
        }
      }
    }
    backgroundColour {
      hex
    }
  }
`;
